'use strict';

var processInclude = require('base/util');
var customUtil = require('./customUtil');

var swiper,
    maxRatioOriginal = 0,
    zoomInFrameID,
    zoomOutFrameID,
    previousTimeStamp,
    timeoutID, timeoutID2,
    transform, origZoomTransform, origImgTransform,
    touchMove = false,
    isMobile = false;

/**
 * Init the zoom functionality
 */
function initZoom() {
    var imageToOpen = 0;
    var imageList = [];
    var altList = [];

    $('#modalZoomLoading').removeClass('d-none');
    $('#zoomModal .modal-body').addClass('hide');

    $('body').on('click', '.primary-images .carousel-item:not(.pdp-video-container) img', function() {
        imageToOpen = $(event.target).data('image') ? $(event.target).data('image') : 0;
        var carouselImages = $(this)
            .parents('.primary-images')
            .find('img');

        $('.zoomer_basic').swiper('destroy');

        $('.zoomer_basic')
            .empty()
            .removeClass('zoomer-element')
            .addClass('swiper-element');

        imageList = [];
        altList = [];
        $.each(carouselImages, function(index, val) {
            imageList.push($(val).attr('data-zoom'));
            altList.push($(val).attr('alt'));
        });

        var html = `<div class="zoomer-controls zoomer-controls-top modal-controls" role="tablist" aria-label="zoom-control-buttons" aria-hidden="true" style="
">
                        <span class="zoomer-zoom-out" tabindex="0" role="tab" aria-label="zoom-out">-</span>
                        <span class="zoomer-zoom-in" tabindex="0" role="tab" aria-label="zoom-in">+</span>
                    </div>`

        $('#zoomModal').find('.modal-content').prepend(html);

        var zoomerOpt = {
                index: imageToOpen,
                // increment: 0.01,
                // interval: 0.1,
                // marginMax: 100,    //Left commented for any future changes
                imageList: imageList,
                altList: altList,
                onImageLoad: function(imageRatio, data) {
                    data.swiper = new Swiper('.swiper', {
                        // Optional parameters
                        direction: 'horizontal',
                        loop: true,
                        grabCursor: true,
                        speed: 900,
                        threshold: 5,
                        followFinger: false,
                        preventInteractionOnTransition: true,
                        centeredSlides: true,
                        effect: 'slide',
                        zoom: {
                            maxRatio: 5,
                        },
                        // If we need pagination
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        },
                        // Navigation arrows
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        on: {
                            afterInit: function (_swiper) {
                                swiper = _swiper
                                maxRatioOriginal = swiper.params.zoom.maxRatio;
                                initZoomControls.apply(_swiper);
                                isMobile = customUtil.isMobile();
                            },
                            slideChange: function (swiper) {
                            },
                            tap: function () {
                                swiper.params.zoom.maxRatio = maxRatioOriginal;
                            },
                            doubleTap: function (swiper) {
                                swiper.params.zoom.maxRatio = maxRatioOriginal;
                                touchMove = false;
                            },
                            touchStart: function (swiper, event) {
                                if(event.touches && event.touches.length > 1){
                                    event.preventDefault();
                                    event.stopPropagation();
                                    touchMove = false;
                                }
                             },
                            touchEnd: function (swiper, event) {

                                if(event.touches && event.touches.length > 1){
                                    return;
                                }

                                touchMove = false;
                            },
                            touchMove: function (swiper) {
                                touchMove = true;
                            },
                            zoomChange: function (swiper, scale, imageEl, slideEl) {

                                var $zoomContainer = $(slideEl).find('.swiper-zoom-container');

                                // enable/disable zoom controls
                                if (scale > swiper.params.zoom.minRatio) {
                                    swiper.allowSlidePrev = swiper.allowSlideNext = false;
                                    $(swiper.navigation.nextEl).css({opacity: 0});
                                    $(swiper.navigation.prevEl).css({opacity: 0});
                                    $(swiper.pagination.el).css({opacity: 0});
                                } else {
                                    swiper.allowSlidePrev = swiper.allowSlideNext = true;
                                    $(swiper.navigation.nextEl).css({opacity: 1});
                                    $(swiper.navigation.prevEl).css({opacity: 1});
                                    $(swiper.pagination.el).css({opacity: 1});
                                }

                                $('.zoomer-zoom-in').css({opacity: 1});
                                $('.zoomer-zoom-out').css({opacity: 1});

                                if (scale >= maxRatioOriginal) {
                                    stopAnimationInit();
                                    $('.zoomer-zoom-in').css({opacity: 0.5});
                                    $('.zoomer-zoom-out').css({opacity: 1});
                                    zoomOutEnable.apply(swiper);
                                } else if (scale <= swiper.params.zoom.minRatio) {
                                    stopAnimationInit();
                                    $('.zoomer-zoom-in').css({opacity: 1});
                                    $('.zoomer-zoom-out').css({opacity: 0.5});
                                    zoomInEnable.apply(swiper);
                                }

                            },
                            slideChange: function (swiper) {
                                $('#modalZoomLoading').addClass('d-none');
                            }, slideChangeTransitionEnd:  function (swiper) {
                                if (isMobile) {
                                    window.requestAnimationFrame(function () {
                                        var $slide = $('.swiper-slide-active');
                                        var data = $slide.data('slider-zoomer-data') || $slide.closest('.swiper-element').data('zoomer');
                                        if (data) {
                                            var $clone = $slide.find('.clone');
                                            var cloneInt = setInterval(function () {
                                                if (!$clone.length) {
                                                    clearInterval(cloneInt)
                                                } else {
                                                    $clone.remove();
                                                }
                                            }, 100);
                                        }
                                    });
                                }
                            }, slideChangeTransitionStart: function (swiper) {
                                if (isMobile) {
                                     data.toggleAnimation = false;
                                }

                            },
                            slideNextTransitionStart: function (swiper) {
                                if (isMobile) {
                                    window.requestAnimationFrame(function () {
                                        var $slideActive = $('.swiper-slide-active');
                                        var $slidePrev = $('.swiper-slide-prev, .swiper-slide-duplicate-prev');

                                        var $holder = $slideActive.find('.holder');

                                        if (!$holder.siblings('.clone').length) {
                                            var $clone = $holder.clone();
                                            $clone.addClass('clone').removeClass('holder');
                                            $holder.parent().append($clone);
                                        }

                                        var data = $slideActive.data('slider-zoomer-data') || $slideActive.closest('.swiper-element').data('zoomer');
                                        if (data) {
                                            var scaleX = data.minWidth / data.naturalWidth,
                                                scaleY = data.minHeight / data.naturalHeight,
                                                centerLeft = data.frameWidth / 2,
                                                centerTop = data.frameHeight / 2;

                                            var $holder = $slideActive.find('.holder');

                                            $holder.css(_prefix('transform', `translate3d(-50%, -50%, 0) scale(${scaleX}, ${scaleY})`))
                                            $holder.css({
                                                left: centerLeft + 'px',
                                                top: centerTop + 'px',
                                                height: data.naturalHeight,
                                                width: data.naturalWidth
                                            });

                                        }

                                        var prevData = $slidePrev.data('slider-zoomer-data') || $slidePrev.closest('.swiper-element').data('zoomer');
                                        if (prevData) {
                                            var prevCenterLeft = prevData.frameWidth / 2,
                                                prevCenterTop = prevData.frameHeight / 2;

                                            $slidePrev.find('.holder')
                                                .css(_prefix('transform', 'translate3d(-50%, -50%, 0) scale(1, 1)'))
                                                .css({left: prevCenterLeft+ 'px', top: prevCenterTop + 'px' , height: prevData.minHeight, width: prevData.minWidth});
                                        }
                                    });
                                }
                            },
                            slidePrevTransitionStart: function (swiper) {
                                if (isMobile) {
                                    window.requestAnimationFrame(function () {
                                        var $slideActive = $('.swiper-slide-active');
                                        var $slideNext = $('.swiper-slide-next, .swiper-slide-duplicate-next');

                                        var $holder = $slideActive.find('.holder');
                                        if (!$holder.siblings('.clone').length) {
                                            var $clone = $holder.clone();
                                            $clone.addClass('clone').removeClass('holder');
                                            $holder.parent().append($clone);
                                        }

                                        var data = $slideActive.data('slider-zoomer-data') || $slideActive.closest('.swiper-element').data('zoomer');
                                        if (data) {
                                            var scaleX = data.minWidth / data.naturalWidth,
                                                scaleY = data.minHeight / data.naturalHeight,
                                                centerLeft = data.frameWidth / 2,
                                                centerTop = data.frameHeight / 2;

                                            var $holder = $slideActive.find('.holder');

                                            $holder.css(_prefix('transform', `translate3d(-50%, -50%, 0) scale(${scaleX}, ${scaleY})`))
                                            $holder.css({
                                                left: centerLeft + 'px',
                                                top: centerTop + 'px',
                                                height: data.naturalHeight,
                                                width: data.naturalWidth
                                            });
                                       }

                                        var nextData = $slideNext.data('slider-zoomer-data') || $slideNext.closest('.swiper-element').data('zoomer');
                                        if (nextData) {
                                            var nextCenterLeft = nextData.frameWidth / 2,
                                                nextCenterTop = nextData.frameHeight / 2;

                                            $slideNext.find('.holder')
                                                .css(_prefix('transform', 'translate3d(-50%, -50%, 0) scale(1, 1)'))
                                                .css({
                                                    left: nextCenterLeft + 'px',
                                                    top: nextCenterTop + 'px',
                                                    height: nextData.minHeight,
                                                    width: nextData.minWidth
                                                });
                                        }
                                    });
                                }
                            }
                        }
                    });
                },
                prependImageCallback: function ($image) {
                    var _swiper = this;
                    window.requestAnimationFrame(function () {
                        _swiper.prependSlide($image);
                    });

                },
                appendImageCallback: function ($image) {
                    var _swiper = this;
                    window.requestAnimationFrame(function () {
                        _swiper.appendSlide($image);
                    });
                }
            };

        $('.zoomer_basic').swiper(zoomerOpt);

        $('#zoomModal').modal();
    });

    // $('body').on('click', '.pdp-video-container', function() {
    //     $('.zoomer_basic').swiper('destroy');
    //     $('.zoomer_basic')
    //         .empty()
    //         .removeClass('zoomer-element');

    //     var iframeSrc = $(this)
    //         .find('iframe')
    //         .attr('src');
    //     if (iframeSrc != null) {
    //         var iframediv = '<iframe class="pdp-zoom-frame" src="' + iframeSrc + '" frameborder="0" allowfullscreen="" data-widths="[0]">';
    //         $('.zoomer_basic').append(iframediv);
    //         $('.zoomer_basic').addClass('iframe-loaded');
    //         $('#zoomModal').modal();
    //         $('body').load('iframe.pdp-zoom-frame', function() {
    //             $('#modalZoomLoading').hide();
    //         });
    //     }
    // });

    $('#zoomModal .closeIcon').on('click', function() {
        if ($('.zoomer_basic').hasClass('iframe-loaded')) {
            $('.zoomer_basic')
                .empty()
                .removeClass('zoomer-element iframe-loaded');
        }

        $('#zoomModal').find('.modal-content').find('.zoomer-controls').remove();

        $('.zoomer_basic').swiper('destroy');

        timeoutID = timeoutID2 = undefined;
        transform = origZoomTransform = origImgTransform = 'unset';
        touchMove = false;


        stopAnimationInit();
    });

    $('#zoomModal').on('shown.bs.modal', function() {
        $('#zoomModal .modal-body').removeClass('hide');

        setTimeout(function() {
            $('.zoomer_wrapper').swiper('resize');
        }, 250);

        $(window).on('resize', function() {
            isMobile = customUtil.isMobile();
            $('.zoomer_wrapper').swiper('resize');
        });
    });
}

function initZoomControls() {
    zoomOutEnable()
    zoomInEnable();
    stopAnimationInit();
}

function stopAnimationInit() {
    $('.zoomer-zoom-in, .zoomer-zoom-out', '.modal-controls').off('mouseup.zoom touchend.zoom').on('mouseup.zoom touchend.zoom', function () {
        cancelAnimationFrame(zoomInFrameID);
        cancelAnimationFrame(zoomOutFrameID);
        previousTimeStamp = undefined;
    });
    $('.zoomer-zoom-in, .zoomer-zoom-out', '.modal-controls').trigger('mouseup.zoom touchend.zoom');
}

function zoomIn(timestamp) {
    if (previousTimeStamp === undefined || timestamp !== previousTimeStamp) {
        previousTimeStamp = timestamp;
        if (swiper.zoom.scale <= maxRatioOriginal) {

            var $zoomContainer = $(swiper.$el.find('.swiper-slide-active .swiper-zoom-container'));
            if (!$zoomContainer.hasClass('no-transition-duration')) {
                $zoomContainer.addClass('no-transition-duration');
                $($zoomContainer.find('.swiper-zoom-target')).addClass('no-transition-duration');
            }

             if (swiper.zoom.scale < 1.02) {
                 swiper.params.zoom.maxRatio = swiper.zoom.scale + 0.001;
                 swiper.zoom.in();
             } else {
                 swiper.params.zoom.maxRatio = swiper.zoom.scale + 0.01;
                 $($zoomContainer.find('.swiper-zoom-target')).css({transform: `translate3d(0px, 0px, 0px) scale3d(${swiper.params.zoom.maxRatio}, ${swiper.params.zoom.maxRatio}, 1)`});
                 swiper.zoom.scale = swiper.zoom.scale + 0.01;
             }
        }
        if (swiper.params.zoom.maxRatio >= maxRatioOriginal) {
            swiper.params.zoom.maxRatio = maxRatioOriginal;
            cancelAnimationFrame(zoomInFrameID);
        } else {
            zoomInFrameID = requestAnimationFrame(zoomIn);
        }
    }


}

function zoomOut(timestamp) {
    if (previousTimeStamp === undefined || timestamp !== previousTimeStamp) {
        previousTimeStamp = timestamp;
        if (swiper.zoom.scale >= swiper.params.zoom.minRatio) {

            var $zoomContainer = $(swiper.$el.find('.swiper-slide-active .swiper-zoom-container'));
            if (!$zoomContainer.hasClass('no-transition-duration')) {
                $zoomContainer.addClass('no-transition-duration');
                $($zoomContainer.find('.swiper-zoom-target')).addClass('no-transition-duration');
            }

            if (swiper.zoom.scale < 1.5) {
                $zoomContainer.removeClass('no-transition-duration');
                $($zoomContainer.find('.swiper-zoom-target')).removeClass('no-transition-duration');
                swiper.zoom.out();
            } else {
                swiper.params.zoom.maxRatio = swiper.zoom.scale - 0.01;
                $($zoomContainer.find('.swiper-zoom-target')).css({transform: `translate3d(0px, 0px, 0px) scale3d(${swiper.params.zoom.maxRatio}, ${swiper.params.zoom.maxRatio}, 1)`});
                swiper.zoom.scale = swiper.zoom.scale - 0.01;
            }
        }

        if (swiper.zoom.scale <= swiper.params.zoom.minRatio)  {
            swiper.params.zoom.maxRatio = maxRatioOriginal;
            $zoomContainer.closest('.swiper-slide-active').removeClass('swiper-slide-zoomed');
            cancelAnimationFrame(zoomOutFrameID);
        } else {
            zoomOutFrameID = requestAnimationFrame(zoomOut);
        }
    }
}

function zoomInEnable() {
    $('.modal-controls .zoomer-zoom-in').on('mousedown.zoom touchstart.zoom', function (e) {
        e.preventDefault();
        e.stopPropagation();
        zoomInFrameID = requestAnimationFrame(zoomIn);
    });
    stopAnimationInit();
}

function zoomOutEnable() {
    $('.modal-controls .zoomer-zoom-out').on('mousedown.zoom touchstart.zoom', function (e) {
        e.preventDefault();
        e.stopPropagation();
        cancelAnimationFrame(zoomInFrameID);
        zoomOutFrameID = requestAnimationFrame(zoomOut);
    });
    stopAnimationInit();
}

function zoomInDisable() {
    cancelAnimationFrame(zoomInFrameID);
    $('.modal-controls .zoomer-zoom-in').off('.zoom');
}

function zoomOutDisable() {
    cancelAnimationFrame(zoomOutFrameID);
    $('.modal-controls .zoomer-zoom-out').off('.zoom');
}

function _prefix(property, value) {
    var r = {};

    r['-webkit-' + property] = value;
    r['-moz-' + property] = value;
    r['-ms-' + property] = value;
    r['-o-' + property] = value;
    r[property] = value;

    return r;
}

$(document).ready(function() {
    let swiper = this;
    processInclude(require('./swiper'));

    if ($('#zoomImages').length > 0) {
        initZoom();
    }
});
